import { useEffect } from "react";
import { useAppDispatch } from "@/store/store";
import { fetchServerSettingsThunk } from "../server/thunks/fetchServerSettingsThunk";

export const useServerSettings = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchServerSettingsThunk());
  }, []);
};
